/** @jsx jsx */

import { PropsWithChildren } from 'react';

import { css, jsx } from '@emotion/core';

const Styles = {
  root: css`
    display: inline-block;
    height: 100%;
    position: relative;
    width: 100%;
  `,
};

// I swear Emotion used to expose this function, but I can't seem to find it any
// more. This is a more basic version of the popular `cx` or `classNames`
// function to combine multiple class names together.
function cx(...classNames: any[]): string {
  return classNames.filter(x => x).join(' ');
}

type Props = {
  autoPlay?: boolean;
  /** Display in a popover (aka "lightbox", aka "modal") */
  popover?: boolean;
  /** Title to show below the video in the popover */
  popoverCaption?: string;
  /** Wistia video ID */
  wistiaID: string;
};

function Video({
  autoPlay = false,
  children,
  popover = false,
  popoverCaption = '',
  wistiaID,
}: PropsWithChildren<Props>) {
  return (
    <div
      className={cx(
        'wistia_embed',
        `wistia_async_${wistiaID}`,
        // https://wistia.com/support/developers/embed-options
        'videoFoam=true',
        'playerColor=666666',
        // https://wistia.com/support/developers/popover-customization
        autoPlay && 'autoPlay=true',
        popover && 'popover=true',
        popover && 'popoverOverlayColor=000000',
        popover && 'popoverOverlayOpacity=0.7',
        !!children && 'popoverContent=html',
        popoverCaption && `popoverCaption=${encodeURIComponent(popoverCaption)}`
      )}
      css={Styles.root}
    >
      {children}
    </div>
  );
}

export default Video;
